<doc-main-panel [sourceApp]="configurations.documentationInput.sourceApp" [pageId]="configurations.documentationInput.pageId"
        [editEnabled]="configurations.documentationInput.editEnabled" [sectionId]="configurations.documentationInput.sectionId"
        [showPanel]="configurations.documentationInput.showPanel"
        (DocumentationLoaded)="onDocumentation_Loaded($event)"></doc-main-panel>
<router-outlet></router-outlet>